import { render, staticRenderFns } from "./UMap.vue?vue&type=template&id=5bf0cde6&scoped=true&"
import script from "./UMap.vue?vue&type=script&lang=js&"
export * from "./UMap.vue?vue&type=script&lang=js&"
import style0 from "./UMap.vue?vue&type=style&index=0&id=5bf0cde6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0cde6",
  null
  
)

export default component.exports